/**
 * Created On : 14th Feb 2018
 * Usage : Displays Warnings of the Chiller's Condition and also shows the utilization perecentage
 * Coprights : Johnson Controls India Pvt Ltd.
 **/

import { Component, Input } from "@angular/core";

@Component({
    selector: 'health-tab',
    styles: [`
        .progress {
            background-color: #e4e4e4;
            border-radius: 20px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) inset;
            height: 20px;
            margin-bottom: 20px;
            overflow: hidden;
            margin-top: 44px;
            margin-left: 16px;
        }
        .progressFill {
            background: #4882c2;
            height: 30px;
        }
        .utilization {
            float: left;
            font-size: 14px;
            margin-top: 48px;
            font-weight:bolder;
        }
        .warning {
            float: left;
            margin-top: 10px !important;
            font-weight: bold;
            font-size:16px;
            color: white;
            width: 100%;
        }
        .utilization-container {
            float: left;
            width: 70%;
            margin-top: 3px;
        }
        .utilization-container p {
            text-align: right;
            margin-right: -36px;
            margin-top: -39px;
            font-weight: bolder;
        }
        .health-check-report {
             display: -webkit-inline-box;
             margin: 10px 0px 10px;
             font-size: 15px;
             line-height:24px
        }
        .health-check-report-categories-first {
            line-height: 46px;
            font-weight: bolder;
        }
        .health-check-report-categories-second {
            line-height: 0px;
            font-weight: bolder;
        }
        .list {
            margin-left: 30px;
        }
        .no-margin-top {
            margin-top: 0px;
        }
        .margin-top-neg-8 {
            margin-top: -8px;
        }
        pre {
            margin: 0;
            font-family: inherit;
            font-weight: 500;
            white-space: pre-wrap;
            white-space: -moz-pre-wrap;
            white-space: -pre-wrap;
            white-space: -o-pre-wrap;
            word-wrap: break-word;
        }
        .red {
            background: #FF0000;
        }
        .orange {
            background: #FFA500;
        }
        .dash-text{
            width: 100%;
            height: 5px;
            border-top: 1px solid #bcbcbc;

        }
     `],
    template: `
    <span text-center [ngClass]="{'red': healthDetail.Status == 'ALARM', 'orange': healthDetail.Status == 'ALERT'}" class="warning">
        {{healthDetail.ChartName}}
    </span>
    <ion-grid text-center>
        <ion-row>
            <ion-col>
                <circle-progress 
                    [space]="-10" 
                    [percent]="healthDetail.AlarmFrequency" 
                    [radius]="60" 
                    [title]="getPercentage(healthDetail.AlarmFrequency)"
                    [outerStrokeWidth]="10" 
                    [innerStrokeWidth]="10" 
                    [outerStrokeColor]="'#FF0000 '"
                    [innerStrokeColor]="'#e7e8ea'" 
                    [animation]="true" 
                    [showSubtitle]="false" 
                    [animationDuration]="300" 
                    [titleFontSize]="24">
                </circle-progress>
                <br/>
                <p> {{'AlarmIndex' | translate}}</p>
            </ion-col>
            <ion-col>
                <circle-progress 
                    [space]="-10" 
                    [percent]="healthDetail.AlertFrequency" 
                    [radius]="60" 
                    [title]="getPercentage(healthDetail.AlertFrequency)" 
                    [outerStrokeWidth]="10" 
                    [innerStrokeWidth]="10"
                    [outerStrokeColor]="'#FFA500'" 
                    [innerStrokeColor]="'#e7e8ea'" 
                    [animation]="true" 
                    [showSubtitle]="false" 
                    [animationDuration]="300"
                    [titleFontSize]="24">
                </circle-progress>
                <br/>
                <p>{{'AlertIndex' | translate}}</p>
            </ion-col>
        </ion-row>
    </ion-grid>
    <span class="utilization">{{'Utilization' | translate}}</span>
    <div class="utilization-container">
        <div class="progress">
            <div class="progressFill" [style.width]="getPercentage(healthDetail.Utilization)"></div>
        </div>
        <p>{{getPrecision(healthDetail.Utilization)}}%</p>
    </div>
    <div>
        <div text-left class="health-check-report">
            <ng-container *ngIf="healthDetail.AlarmDescription">
                <pre>{{healthDetail.AlarmDescription}}</pre>
            </ng-container>
            <ng-container *ngIf="healthDetail.AlertDescription">
                <pre [innerHTML]="healthDetail.AlertDescription"></pre>
            </ng-container>
        </div>
    </div><br/>   
    <div class="dash-text"></div>
    `
})
export class HealthTabComponent {

    @Input() healthDetail: any;

    getPercentage(type) {
        return type + "%";
    }

    getPrecision(type: string) {
        if (type) {
            return parseFloat(type).toPrecision(2);
        }
    }
}




// WEBPACK FOOTER //
// ./src/components/health/health-components/health-tab.component.ts